import { Button, Flex, Menu, MenuButton, MenuGroup, MenuItem, MenuList, Stack, Text, Tooltip } from "@chakra-ui/react";
import { Icon } from "@pufflig/prompt-studio-ui";

interface SchemaSectionProps {
  readOnly?: boolean;
  title: string;
  description: string;
  buttonText: string;
  menuGroupText?: string;
  children: React.ReactNode;
  variables?: { id: string; name: string; description?: string }[];
  onAddField?: (variableName: string, variableId: string) => void;
}

export const SchemaSection = (props: SchemaSectionProps) => {
  const { title, description, buttonText, menuGroupText, children, variables = [], readOnly, onAddField } = props;
  return (
    <Flex direction="column" gap="2">
      <Stack direction="column" alignItems="left" justifyContent="space-between">
        <Text textStyle="heading/2">{title}</Text>
        <Text textStyle="body/M" color="foreground.secondary">
          {description}
        </Text>
      </Stack>
      {children}
      {!readOnly && (
        <Flex>
          <Menu>
            {onAddField && (
              <Tooltip label="Add a field" aria-label="Add a field">
                <MenuButton
                  isDisabled={!variables.length}
                  size="sm"
                  as={Button}
                  leftIcon={<Icon name="add" />}
                  variant="ghost"
                >
                  {buttonText}
                </MenuButton>
              </Tooltip>
            )}
            <MenuList>
              <MenuGroup title={menuGroupText}>
                {variables.map((variable) => {
                  return (
                    <MenuItem
                      key={variable.id}
                      value={variable.id}
                      gap="1"
                      onClick={() => {
                        onAddField?.(variable.name, variable.id);
                      }}
                    >
                      <Icon name="icon-document-1" />
                      {variable.name}
                    </MenuItem>
                  );
                })}
              </MenuGroup>
            </MenuList>
          </Menu>
        </Flex>
      )}
    </Flex>
  );
};
